import { css } from "emotion";

export const container = css`
    border-radius: 20px;
    border: 1px solid #aaa;
    display: flex;
    justify-content: space-between;
    padding: 3px;
    align-items: center;
    min-width: 120px;
    max-height: 32px;
    color: #b43034;
    font-size: 12px;
    background-color: #fff;
    height: 30px;
    box-sizing: border-box;
`;

export const dangerIcon = css`
    width: 24px;
    height: 24px;
    fill: #b43034;
    margin-left: 6px;
`;

export const accept = css`
    fill: #338b2b;
`;

export const validationText = css`
    font-size: 12px;
    font-family: Arial;
    margin-left: 8px;
`;